import { cx } from '../lib/cx';

/** The document lifecycle statuses shown in tables and detail headers. */
export type DocStatus =
  | 'Classified'
  | 'Needs review'
  | 'OCR running'
  | 'Classifying'
  | 'Scoring confidence'
  | 'Failed';

interface StatusStyle {
  /** Text colour token — success text uses --ok-ink for AA. */
  text: string;
  /** Dot colour token. */
  dot: string;
}

const STATUS: Record<DocStatus, StatusStyle> = {
  Classified: { text: 'var(--ok-ink)', dot: 'var(--ok)' },
  'Needs review': { text: 'var(--warn)', dot: 'var(--warn-dot)' },
  'OCR running': { text: 'var(--a-ink)', dot: 'var(--accent)' },
  Classifying: { text: 'var(--a-ink)', dot: 'var(--accent)' },
  'Scoring confidence': { text: 'var(--a-ink)', dot: 'var(--accent)' },
  Failed: { text: 'var(--bad)', dot: 'var(--bad)' },
};

export interface StatusBadgeProps {
  status: DocStatus;
  className?: string;
}

/**
 * Status as a 7px dot PLUS its text label in the same semantic colour — never
 * colour alone (WCAG 1.4.1, design-reference §6.1). The dot is decorative; the
 * label carries the meaning.
 */
export function StatusBadge({ status, className }: StatusBadgeProps): React.JSX.Element {
  const style = STATUS[status];
  return (
    <span className={cx('ds-status', className)} style={{ color: style.text }}>
      <span className="ds-status__dot" aria-hidden="true" style={{ background: style.dot }} />
      {status}
    </span>
  );
}
